import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';
import * as events from 'devextreme/events';

import {Tooltip as DXTooltip} from 'devextreme-react';


export default class Tooltip extends Component {
    constructor(props) {
        super(props);

        this.state = {visible: this.props.visible, target: this.props.target};

        // this.onInitialized = this.onInitialized.bind(this);
        this.onShowing = this.onShowing.bind(this);
        this.onHiding = this.onHiding.bind(this);
    }

    componentDidMount() {
        const target = document.getElementById(this.props.target);
        this.setState({target});

        events.on(target, this.props.showEvent, this.onShowing);
        events.on(target, this.props.hideEvent, this.onHiding);
    }

    // componentWillUnmount() {
    //     events.off(this.state.target, this.props.showEvent);
    //     events.off(this.state.target, this.props.hideEvent);
    // }

    // onInitialized(e) {
    //     const target = document.getElementById(this.props.target);
    //     this.setState({target});
    //     // events.on(target, this.props.showEvent, this.onShowing)
    //     // events.on(target, this.props.hideEvent, this.onHiding)
    // }

    onShowing(e) {
        this.setState({visible: true});
    }

    onHiding(e) {
        this.setState({visible: false});
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXTooltip
                {...omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                // onInitialized={this.props.onInitialized || this.onInitialized}
                // onShowing={this.props.onShowing || this.onShowing}
                // onHiding={this.props.onHiding || this.onHiding}
                visible={this.state.visible}
                target={this.state.target}
            />
        )
    }
}

Tooltip.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    animation: PropTypes.object,
    closeOnBackButton: PropTypes.bool,
    closeOnOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    container: PropTypes.string,
    // contentTemplate: PropTypes.string,
    deferRendering: PropTypes.bool,
    disabled: PropTypes.bool,
    elementAttr: PropTypes.object,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    hideEvent: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    hint: PropTypes.string,
    hoverStateEnabled: PropTypes.bool,
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    onContentReady: PropTypes.func,
    onDisposing: PropTypes.func,
    onHidden: PropTypes.func,
    onHiding: PropTypes.func,
    onInitialized: PropTypes.func,
    onOptionChanged: PropTypes.func,
    onShowing: PropTypes.func,
    onShown: PropTypes.func,
    position: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'left', 'right', 'top']), PropTypes.object]),
    rtlEnabled: PropTypes.bool,
    shading: PropTypes.bool,
    shadingColor: PropTypes.string,
    showEvent: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    target: PropTypes.string,
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

Tooltip.defaultProps = {
    animation: {show: {type: 'fade', from: 0, to: 1}, hide: {type: 'fade', to: 0}},
    children: null,
    closeOnBackButton: true,
    closeOnOutsideClick: true,
    // container: undefined,
    // contentTemplate: 'content',
    deferRendering: true,
    disabled: false,
    elementAttr: {},
    height: 'auto',
    // hideEvent: undefined,
    // hint: undefined,
    hoverStateEnabled: false,
    maxHeight: null,
    maxWidth: null,
    minHeight: null,
    minWidth: null,
    onContentReady: null,
    onDisposing: null,
    onHidden: null,
    onHiding: null,
    onInitialized: null,
    onOptionChanged: null,
    onShowing: null,
    onShown: null,
    position: 'bottom',
    rtlEnabled: false,
    shading: false,
    shadingColor: '',
    // showEvent: undefined,
    // target
    visible: false,
    width: 'auto'
};
